import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { PersonShippingAddressEditPage } from 'src/app/modals/person-shipping-address-edit/person-shipping-address-edit.page';

const routes: Routes = [
  {
    path: '',
    component: PersonShippingAddressEditPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [PersonShippingAddressEditPage]
})
export class PersonShippingAddressEditPageModule {}
